<template>
  <div class="auth-page admin-page admin-page-panel">
    <div class="page-toolbar">
      <div class="toolbar-left">
        <a-input v-model="query.batchNo" placeholder="批次搜索（赛季/赛事方名）" allow-clear style="width:220px;" @pressEnter="loadData" @change="query.batchNo || loadData()">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-button type="primary" icon="search" @click="loadData">查询</a-button>
      </div>
      <div class="toolbar-right">
        <a-button type="primary" icon="plus" @click="openGenerate">生成邀请码</a-button>
      </div>
    </div>

    <a-table :columns="columns" :data-source="data" rowKey="batchNo" :loading="loading"
      :pagination="pagination" @change="handleTableChange" size="middle">
      <span slot="batch" slot-scope="text, record">
        <div class="cell-name">{{ record.batchNo }}</div>
        <div class="cell-sub">{{ record.totalCodes }} 个码</div>
      </span>
      <span slot="usage" slot-scope="text, record">
        <div class="usage-line">
          <a-progress :percent="usagePercent(record)" :status="usageStatus(record)" :show-info="false" style="width:120px;margin-right:8px;" />
          <span>{{ record.usedTotal }} / {{ record.quotaTotal }}</span>
        </div>
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag :color="usagePercent(record) >= 100 ? 'blue' : 'green'">{{ usagePercent(record) >= 100 ? '已用完' : '可用' }}</a-tag>
      </span>
      <span class="admin-row-actions" slot="action" slot-scope="text, record">
        <a @click="showDetail(record)">查看码</a>
        <a-divider type="vertical" />
        <a-popconfirm title="该批次码作废后无法恢复，确定作废？" @confirm="voidBatch(record)">
          <a style="color:#FF4D4F;">作废批次</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="showGenerate" title="生成邀请码" @ok="handleGenerate" :confirmLoading="generating" width="420px">
      <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="批次备注">
          <a-input v-model="generateForm.batchNo" placeholder="如：2026赛季" />
        </a-form-item>
        <a-form-item label="码数量">
          <a-input-number v-model="generateForm.count" :min="1" :max="1000" style="width:100%;" />
        </a-form-item>
        <a-form-item label="每码次数">
          <a-input-number v-model="generateForm.quota" :min="1" :max="5000" style="width:100%;" />
          <div class="form-tip">一个码可多次核销（如给赛事方一个码，运动员可重复使用）</div>
        </a-form-item>
        <a-form-item label="有效期(天)">
          <a-input-number v-model="generateForm.days" :min="1" :max="3650" style="width:100%;" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model="showCodes" :title="`批次明细：${detailBatch}`" :footer="null" width="780px">
      <a-table :columns="detailColumns" :data-source="detailData" rowKey="id" size="small" :pagination="false">
        <span slot="code" slot-scope="text, record">
          <span class="code-text">{{ record.code }}</span>
        </span>
        <span slot="usage" slot-scope="text, record">
          {{ record.usedCount }} / {{ record.totalQuota }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 0 ? 'green' : record.status === 1 ? 'blue' : 'red'">{{ record.status === 0 ? '可用' : record.status === 1 ? '已核销' : '作废' }}</a-tag>
        </span>
      </a-table>
    </a-modal>

    <a-modal v-model="showCodesResult" title="生成的邀请码（一次性展示，请立即复制）" :footer="null" width="560px">
      <div class="codes-result">
        <a-alert type="info" :message="`共 ${codesResult.length} 个，每码可用 ${codesQuota} 次，有效期至 ${codesExpire}`" show-icon style="margin-bottom:12px;" />
        <div class="code-box">{{ codesResult.join('  ') }}</div>
        <a-button type="primary" block @click="copyCodes">复制全部</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { generateInviteCodes, getInviteCodeBatches, getInviteCodesByBatch, voidInviteCodeBatch } from '@/api'

export default {
    name: 'InviteCodes',
    data() {
        return {
            data: [],
            total: 0,
            loading: false,
            query: { batchNo: '', page: 1, size: 20 },
            pagination: { current: 1, pageSize: 20, showSizeChanger: true, showTotal: t => `共 ${t} 个批次` },
            showGenerate: false,
            generating: false,
            generateForm: { batchNo: '', count: 20, quota: 1, days: 90 },
            showCodes: false,
            detailBatch: '',
            detailData: [],
            showCodesResult: false,
            codesResult: [],
            codesQuota: 1,
            codesExpire: '',
            columns: [
                { title: '批次', dataIndex: 'batch', scopedSlots: { customRender: 'batch' }, width: 200 },
                { title: '核销进度', dataIndex: 'usage', scopedSlots: { customRender: 'usage' } },
                { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
                { title: '最早过期', dataIndex: 'expireMin', width: 170 },
                { title: '创建时间', dataIndex: 'createMax', width: 170 },
                { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 150 }
            ],
            detailColumns: [
                { title: '邀请码', dataIndex: 'code', scopedSlots: { customRender: 'code' }, width: 170 },
                { title: '核销', dataIndex: 'usage', scopedSlots: { customRender: 'usage' }, width: 90 },
                { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
                { title: '有效期至', dataIndex: 'expireAt', width: 170 },
                { title: '创建时间', dataIndex: 'createTime', width: 170 }
            ]
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            getInviteCodeBatches({ ...this.query }).then(res => {
                const data = res.data || {}
                this.data = data.list || []
                this.total = data.total || 0
            }).finally(() => { this.loading = false })
        },
        handleTableChange(pagination) {
            this.query.page = pagination.current
            this.query.size = pagination.pageSize
            this.pagination = pagination
            this.loadData()
        },
        usagePercent(record) {
            const quota = Number(record.quotaTotal) || 0
            if (!quota) return 0
            return Math.min(Math.round((Number(record.usedTotal) / quota) * 100), 100)
        },
        usageStatus(record) {
            return this.usagePercent(record) >= 100 ? 'success' : 'active'
        },
        openGenerate() {
            this.generateForm = { batchNo: '', count: 20, quota: 1, days: 90 }
            this.showGenerate = true
        },
        handleGenerate() {
            if (!this.generateForm.batchNo.trim()) {
                this.$message.warning('请填写批次备注（赛季/赛事方名）')
                return
            }
            this.generating = true
            generateInviteCodes(this.generateForm).then(res => {
                const data = res.data || {}
                this.codesResult = data.codes || []
                this.codesQuota = data.quota || 1
                this.codesExpire = data.expireAt || ''
                this.showGenerate = false
                this.$message.success(`已生成 ${this.codesResult.length} 个邀请码`)
                this.showCodesResult = true
                this.loadData()
            }).finally(() => { this.generating = false })
        },
        showDetail(record) {
            this.detailBatch = record.batchNo
            getInviteCodesByBatch({ batchNo: record.batchNo }).then(res => {
                this.detailData = (res.data && res.data.list) || []
                this.showCodes = true
            })
        },
        voidBatch(record) {
            voidInviteCodeBatch({ batchNo: record.batchNo }).then(res => {
                this.$message.success(res.msg || '已作废')
                this.loadData()
            })
        },
        copyCodes() {
            if (!this.codesResult.length) return
            wxCopy(this.codesResult.join('\n'))
        }
    }
}

function wxCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    try {
        document.execCommand('copy')
    } finally {
        document.body.removeChild(textarea)
    }
}
</script>

<style scoped>
.cell-name {
    font-weight: 600;
}
.cell-sub {
    font-size: 12px;
    color: #999;
}
.usage-line {
    display: flex;
    align-items: center;
    font-size: 13px;
}
.code-text {
    font-family: monospace;
    font-weight: 600;
    letter-spacing: 1px;
}
.code-box {
    font-family: monospace;
    background: #f7f8fa;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;
    word-break: break-all;
    line-height: 1.8;
    max-height: 260px;
    overflow-y: auto;
}
.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
    line-height: 1.5;
}
.page-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
